import React, { useEffect, useState } from "react";
import { handleScrollUp } from '../helpers/helpers';

function UpArrow() {
    const [showElement, setShowElement] = useState(false);

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
  
      // Calculate the middle of the document
      const middlePosition = documentHeight / 2;
  
      // Show the element when scrolled past the middle, hide it at the top
      if (scrollPosition > middlePosition - windowHeight / 2) {
        setShowElement(true);
      } else {
        setShowElement(false);
      }
    };
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
    return(
        <div className="arrow__wrapper" onClick={handleScrollUp}>
            <div className={`arrow-up ${showElement ? 'visible' : 'hidden'}`}></div>
        </div>
    )
}

export default UpArrow;